export default __webpack_public_path__ + "static/media/cai-design02.b79bbdd4.jpg";